module.exports = __webpack_public_path__ + "static/pic10.9354976d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic10.jpg
// module id = 519
// module chunks = 23718644409033